var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 15,
    fill: "#B9C1D9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0638 19.5279C35.9203 15.6023 32.7331 14.0582 28.637 13.3866L28.9419 7.97822L25.7522 7.74679L25.4556 13.0128C24.617 12.9517 23.759 12.9066 22.9064 12.8622L23.2057 7.5613L20.0179 7.32953L19.7121 12.7364C19.0209 12.7008 18.3418 12.6649 17.6806 12.6171L17.6812 12.6002L13.2821 12.2787L13.0847 15.7949C13.0847 15.7949 15.4427 15.9199 15.4011 15.9616C16.6928 16.0558 17.0698 16.8607 17.1547 17.5376L16.8076 23.699C16.8966 23.7059 17.0127 23.7181 17.1435 23.7466C17.0371 23.7389 16.9237 23.7301 16.8064 23.7227L16.319 32.3542C16.2389 32.7697 15.9622 33.4216 15.0594 33.3575C15.0982 33.3977 12.7409 33.1884 12.7409 33.1884L11.8854 37.074L16.0363 37.3757C16.8087 37.4329 17.568 37.5017 18.314 37.5606L18.0071 43.0308L21.1932 43.2628L21.4981 37.8505C22.372 37.9328 23.218 38.0015 24.0448 38.0609L23.7397 43.448L26.9295 43.6794L27.2381 38.2191C32.6185 38.2915 36.4501 37.1701 37.209 32.0063C37.8211 27.8485 36.0191 25.8426 33.0178 24.8668C34.922 24.0292 36.1736 22.4006 36.0638 19.5279ZM30.942 30.8997C30.7133 34.9877 23.9581 34.0298 21.7963 33.8747L22.2057 26.6272C24.3679 26.7851 31.1825 26.636 30.942 30.8997ZM30.0349 20.5665C29.8243 24.2854 24.1932 23.4404 22.3926 23.3095L22.7634 16.7365C24.564 16.8674 30.253 16.6877 30.0349 20.5665Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.e61c308850b781c1049c4b4100cadb33.svg";
export { ForwardRef as ReactComponent };